import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import REGISTRATION_FIELDS from './constants';
import styles from './RegistrationContainer.scss';
import { validateAuthPhoneNumber } from '../../utils/validate';

class RegistrationEmailPhoneBlock extends React.Component {
  render() {
    const { translate, renderEmailInput, renderPhoneInput, isRtl } = this.props;
    return (
      <div className={styles.rowBlock}>
        <div className={styles.columnBlock}>
          <div className={styles.title}>
            {translate('authenticationPage', 'email')}
          </div>
          {renderEmailInput()}
        </div>
        <div className={styles.columnBlock}>
          <div className={styles.title}>
            {translate('authenticationPage', 'phoneNumber')}
          </div>
          <Field
            name={REGISTRATION_FIELDS.PHONE}
            type="text"
            required
            translate={translate}
            isRtl={isRtl}
            component={renderPhoneInput}
            validate={validateAuthPhoneNumber}
          />
        </div>
      </div>
    );
  }
}

RegistrationEmailPhoneBlock.propTypes = {
  translate: PropTypes.func,
  renderEmailInput: PropTypes.func,
  renderPhoneInput: PropTypes.func,
  isRtl: PropTypes.bool
};

export default RegistrationEmailPhoneBlock;
